<template>
    <v-row @keydown="scanMode!==null && scanMode">
        <v-col cols="12" lg="6" md="9">
            <v-card class="mt-5">
                <v-card-title class="grey lighten-4 p-2" v-if="!swipeMode">
<!--                    <h5 class="m-0 font-weight-bold text-break" v-if="(!prepay && reservationType==='kiosk' && only_save_card_at_advanced) || (prepay && only_save_card_at_prepay)">-->
<!--                        Please enter your credit card to save this reservation, you will not be charged at this time-->
<!--                    </h5>-->
                    <h4 class="m-0">
                        <span class=" error--text"> Reservation Total:</span> <span class="blue--text text--accent-4">${{ amount }}</span>
                    </h4>
                </v-card-title>
                <v-card-title class="grey lighten-4 p-2" v-if="swipeMode && !fullCharge">
                    <h5 class="m-0 font-weight-bold error--text text-break">
                        We are saving your card information and are not charging you at this time
                    </h5>
                </v-card-title>
                <div class="p-2">
                    <span class="mt-5 error--text  text-break" v-if="reservation.is_seasonal && securitydeposit && !swipeMode && frontend_view_folder == 'frontend.highcountryskiandtennis'">
                        Please Enter Credit Card Information that is used as a security Deposit.
                    </span>

<!--                    <template v-if="is_seasonal && swipeMode">-->
<!--                        <div> Packages: <span class="blue&#45;&#45;text text&#45;&#45;accent-4">${{ parseFloat( cost.total_packages_price ).toFixed(2) }}</span></div>-->
<!--                        <div> Add-ons: <span class="blue&#45;&#45;text text&#45;&#45;accent-4">${{ parseFloat( cost.total_addon_price ).toFixed(2) }}</span></div>-->
<!--                        <div> Sub Total: <span class="blue&#45;&#45;text text&#45;&#45;accent-4">${{ parseFloat( cost.sub_total ).toFixed(2) }}</span></div>-->
<!--                        <div> Tax: ( {{  cost.tax_percent }}% ) <span class="blue&#45;&#45;text text&#45;&#45;accent-4">${{ parseFloat( cost.tax_amount ).toFixed(2) }}</span></div>-->
<!--                    </template>-->
                    <template v-if="((!securitydeposit && is_seasonal && frontend_view_folder == 'frontend.highcountryskiandtennis') || !is_seasonal || (is_seasonal && frontend_view_folder !== 'frontend.highcountryskiandtennis')) && swipeMode">
                        <div :class="(is_seasonal && swipeMode)?'error--text':'mt-5 error--text'"> Reservation Total: <span class="blue--text text--accent-4">${{ amount }}</span></div>
                    </template>
                    <template v-if="securitydeposit && swipeMode && is_seasonal && frontend_view_folder == 'frontend.highcountryskiandtennis'">
                        <div class=""> Total Rental: <span class="blue--text text--accent-4">${{ parseFloat( parseFloat(amount) - cost.deposit_total ).toFixed(2) }}</span></div>
                        <div class="error--text"> Deposit: <span class="blue--text text--accent-4">${{ parseFloat( cost.deposit_total ).toFixed(2) }}</span></div>
                        <div class="mb-5 error--text"> Total: <span class="blue--text text--accent-4">${{ parseFloat( amount ).toFixed(2) }}</span></div>
                    </template>
                    <template v-if="cash_pay_switch && (reservation.is_from_kiosk == 1 && (((reservation.is_seasonal && seasonal_kiosk_cash_pay) || (!reservation.is_seasonal && kiosk_cash_pay))))">
                    <span class="mt-5">
                        <with-validation :context='self()' v-slot="{bind,on}" field="kiosk_cash_pay">
                            <v-checkbox
                                v-bind="bind"
                                v-on="on"
                                :true-value="true"
                                :false-value="false"
                            >
                                <template v-slot:label>
                                    <div>
                                        I prefer to pay cash at the register
                                    </div>
                                </template>
                            </v-checkbox>
                        </with-validation>
                    </span>
                    </template>
                    <div class=" mt-4 mb-5">
                        <v-btn
                            v-if="turn_off_swipe_kiosk"
                            :color="swipeButtonColor"
                            :data-activated=dataActivated
                            @click="scanningMode()"
                        >
                            Click here, and swipe your card
                        </v-btn>
                    </div>
                    <with-validation field="cc" v-slot="{bind,on}">
                        <v-text-field
                            class="mt-1"
                            outlined
                            clearable
                            label="Credit Card"
                            type="text"
                            v-mask="'NNNN NNNN NNNN NNNN'"
                            v-bind="bind"
                            v-on="on"
                        >

                            <template v-slot:append>
                                <img
                                    class="d-none d-md-block"
                                    width="130"
                                    height="24"
                                    src="/img/creditcards.png"
                                    alt=""
                                >
                            </template>
                        </v-text-field>
                    </with-validation>
                    <v-text-field
                        class="mt-1"
                        name="swipedata"
                        v-model="swipeData"
                        type="text"
                        @keyup="scanKeyUp"
                        @keydown.enter.native="onEnter"
                        ref="swipe-data"
                        style="position:absolute; right: 10000px;"
                    ></v-text-field>
                    <v-row class="mt-2">

                        <v-col cols="4">
                            <with-validation field="expiration_month" v-slot="{bind,on}">
                                <v-select
                                    label="MM"
                                    :items="available_months"
                                    dense
                                    :menu-props="{auto:true,offsetY:true,contentClass: 'big-menu'}"
                                    v-bind="bind"
                                    v-on="on"
                                    ref="exp_month"
                                ></v-select>
                            </with-validation>
                        </v-col>
                        <v-col cols="4">
                            <with-validation field="expiration_year" v-slot="{bind,on}">
                                <v-select
                                    label="YY"
                                    :items="available_years"
                                    dense
                                    :menu-props="{auto:true,offsetY:true,contentClass: 'big-menu'}"
                                    v-bind="bind"
                                    v-on="on"
                                    ref="exp_year"
                                ></v-select>
                            </with-validation>
                        </v-col>
                        <v-col class="d-flex flex-row">
                            <div style="padding-bottom: 25px;flex-basis: 0; flex-grow: 1;"
                                 class="desktop-block d-flex justify-content-center"
                            >
                                <v-divider vertical class="mx-4"></v-divider>
                            </div>

                            <with-validation field="cvv" v-slot="{bind,on}">
                                <v-text-field
                                    dense
                                    style="flex-basis: 100px;flex-grow: 0"
                                    outlined
                                    label="cvv"
                                    type="text"
                                    v-mask="'####'"
                                    v-bind="bind"
                                    v-on="on"
                                ></v-text-field>
                            </with-validation>
                        </v-col>
                    </v-row>
                </div>
            </v-card>

        </v-col>
        <v-col cols="12">
            <with-validation field="agreement" v-slot="{bind,on}">
                <v-checkbox v-bind="bind"
                            v-on="on">

                    <template v-slot:label>
                        I have read and agree to the
                        &nbsp;<a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_terms'})">{{ terms_and_conditions_title }}</a>
                        ,
                        &nbsp;<a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_privacy_policy'})">{{ privacy_policy_title }}</a>&nbsp;
                        and
                        &nbsp;<a href="#" @click.stop.prevent="ui__openModalByName({name:'dialog_cancelation_policy'})">{{ cancellation_policy_title }}</a>
                    </template>
                </v-checkbox>
            </with-validation>
        </v-col>
    </v-row>
</template>

<script>
import WithValidation           from "../../../../components/inputs/WithValidation";
import UiManagerMixin           from "../../../../mixins/UiManagerMixin";
import ValidatableComponent     from "../../../../mixins/ValidatableComponent";
import reservation_form__fields from "../../../../validation/fields/reservation_form__fields";
import cc_form__rules           from "../../../../validation/scenarios/cc_form__rules";
import reservation_form__rules  from "../../../../validation/scenarios/reservation_form__rules";
import step_2                   from "../../validation/step_2";
import {mapActions} from "vuex";
import $ from 'jquery'

export default {
    name      : "PaymentWidget",
    components: {WithValidation},
    props     : ['amount','validationId', 'reservationType', 'swipeMode', 'fullCharge', 'prepay'],
    data      : () => ({
        intervalHandler: null,
        scanMode: null,
        dataActivated: false,
        swipeData: "",
        swipeButtonColor: "",
    }),
    mixins    : [ValidatableComponent, UiManagerMixin],
    methods   : {
        scanningMode(){
            this.scanMode = true;
            this.swipeData = "";
            if( ! this.dataActivated){
                this.dataActivated = true;
                this.swipeButtonColor = 'primary';

                this.$nextTick(() => {
                    this.intervalHandler = setInterval(() => {
                        this.$refs['swipe-data'].focus();
                    }, 100);
                })

            } else {
                this.scanMode = true;
                this.dataActivated = true;
                this.swipeButtonColor = '';

                $(document).off("keydown"); // ? for vue
                clearInterval(this.intervalHandler);
            }
        },
        onEnter(){
            return false;
        },
        scanKeyUp(){
            setTimeout(function(){
                if (this.scanMode) {
                    getSwipedata();
                }

            }, 500)
        },

        getSwipedata(){
            // let swiptedata = 'B4744866010346985^HARRELL/MARC LOVETT^22062010000000008130001300000004744860010343564=20082010000000008130';

            let regext = /(\D{1})(\d.{15})([^+])([a-zA-Z]+\/.+\^)(\d{4})/g;
            let result = regext.exec(this.swipeData);
            console.log(result, "result");
            let cardNo = result[2];
            if (cardNo.charAt(cardNo.length - 1) == '^') {
                cardNo = cardNo.slice(0, -1);
            }
            let expiry = result[5];
            let year = expiry.substring(0, 2);
            let month = expiry.substring(2, 4);
            this.$store.commit('set_model_value', {
                path : 'model.payment.cc',
                value: cardNo
            });
            this.$store.commit('set_model_value', {
                path : 'model.payment.expiration_month',
                value: month
            });
            this.$refs.exp_month.blur();
            this.$store.commit('set_model_value', {
                path : 'model.payment.expiration_year',
                value: "20"+year
            });
            this.$refs.exp_year.blur();


            this.scanMode = true;


            setTimeout(function(){
                $(document).off("keydown");
            }, 2500)

            this.dataActivated = false;
            this.swipeButtonColor = '';

            clearInterval(this.intervalHandler);
        }
    },
    computed  : {
        available_months() {
            return ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
        },
        available_years() {
            const currentYear = (new Date()).getFullYear();
            const availableYears = [currentYear.toString()];
            for (let i = currentYear; i < currentYear + 15; i++) {
                availableYears.push(i.toString());
            }
            return availableYears;
        },
        payment() {
            return this.$store.state.model.payment;
        },
        only_save_card_at_advanced() {
            return parseInt(this.$store.state.resources.config.only_save_card_at_advanced);
        },
        turn_off_swipe_kiosk() {
            return parseInt(this.$store.state.resources.config.turn_off_swipe_kiosk);
        },
        prepay_payment(){
            return parseInt(this.$store.state.resources.config.prepay_payment);
        },
        only_save_card_at_prepay(){
            return parseInt(this.$store.state.resources.config.only_save_card_at_prepay);
        },
        securitydeposit(){
            return this.$store.state.resources.config.securitydeposit;
        },
        reservation() {
            return this.$store.state.model.reservation;
        },
        cost() {
            return this.$store.state.model.cost;
        },
        is_seasonal(){
            return this.$store.state.model.reservation.is_seasonal;
        },
        frontend_view_folder() {
            return this.$store.state.resources.config.frontend_view_folder;
        },
        seasonal_kiosk_cash_pay() {
            return parseInt(this.$store.state.resources.config.seasonal_kiosk_cash_pay);
        },
        kiosk_cash_pay() {
            return parseInt(this.$store.state.resources.config.kiosk_cash_pay);
        },
        cash_pay_switch() {
            return parseInt(this.$store.state.resources.config.cash_pay_switch);
        },
        gatewayMode(){
            return this.$store.state.resources.config.gateway_mode;
        },
        gateway(){
            return this.$store.state.resources.config.gateway;
        },
        terms_and_conditions_title() {
            return this.$store.state.resources?.policy_and_terms?.terms_and_conditions?.title || 'Terms & Conditions'
        },
        privacy_policy_title() {
            return this.$store.state.resources?.policy_and_terms?.privacy_policy?.title || 'Privacy Policy'
        },
        cancellation_policy_title() {
            return this.$store.state.resources?.policy_and_terms?.cancellation_policy?.title || 'Cancellation Policy'
        },
    },
    watch:{
        validationId(val){
            if(val) {
                this.withValidation({validationId: val})
            }
        }
    },
    mounted() {
        // let next_year = parseInt(new Date().getFullYear()) + 1;
        // next_year = next_year.toString();
        // this.$store.commit('set_model_value', {
        //     path : 'model.payment.expiration_year',
        //     value: next_year
        // });
        if(this.validationId === false) {
            const self = this;
            this.withValidation(
                {
                    getModel() {
                        return self.$store.state.model.payment;
                    },
                    rules : this.$store.state.resources.config.gateway !== "stripe" ? cc_form__rules: '',
                    fields: {}
                }
            )
        }
        if(this.gateway == "authorize" && this.gatewayMode == "demo"){
        
            let next_year = parseInt(new Date().getFullYear()) + 5;
            next_year = next_year.toString();
            this.$store.commit('set_model_value', {
                path : 'model.payment.expiration_year',
                value: next_year
            });
            this.$store.commit('set_model_value', {
                path : 'model.payment.expiration_month',
                value: '05'
            });
            this.$store.commit('set_model_value', {
                path : 'model.payment.cvv',
                value: '123'
            });
            this.$store.commit('set_model_value', {
                path : 'model.payment.cc',
                value: '4111 1111 1111 1111'
            });
        }
    }
}
</script>

<style>
    .v-input--selection-controls .v-input__slot > .v-label{
        display: inline-block !important;
    }
</style>

<style scoped>
    @media (max-width: 575.98px) {
        .desktop-block{
            display: none !important;
        }
        .mobile-block{
            display: block;
        }
    }

    @media (min-width: 576px){
        .mobile-block{
            display: none;
        }
        .desktop-block{
            display: flex !important;
        }
    }
</style>
